export class SelectedService {
  id;
  title;
  duration;
  estimatedTimeMin;
  price;
  description;
  moreInfo;

  constructor(id, title, estimatedTimeMin, duration, price, description, moreInfo) {
    this.id = id;
    this.title = title;
    this.estimatedTimeMin = estimatedTimeMin;
    this.duration = duration;
    this.price = price;
    this.description = description;
    this.moreInfo = moreInfo;
  }
}
